// const BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:3001/api/v1';
const BASE_URL = process.env.REACT_APP_API_URL ?? 'https://api.v1.eudora-aromas.com/api/v1';

// async function request<T>(path: string, options?: RequestInit): Promise<T> {
//   let res: Response;
//   try {
//     res = await fetch(`${BASE_URL}${path}`, {
//       headers: { 'Content-Type': 'application/json', ...options?.headers },
//       ...options,
//     });
//   } catch (networkErr) {
//     console.error('[API] Network/CORS error:', networkErr);
//     throw new Error('Erreur réseau. Vérifiez votre connexion internet.');
//   }

//   let json: any;
//   try {
//     json = await res.json();
//   } catch {
//     console.error('[API] Non-JSON response, status:', res.status);
//     throw new Error(`Erreur serveur (${res.status})`);
//   }

//   if (!res.ok || !json.success) {
//     console.error('[API] Request failed:', res.status, json);
//     throw new Error(json.error ?? `Request failed: ${res.status}`);
//   }
//   return json.data as T;
// }

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const url = `${BASE_URL}${path}`;
  let res: Response;
  
  try {
    res = await fetch(url, {
      ...options,
      headers: { 'Content-Type': 'application/json', ...options?.headers },
    });
  } catch (networkErr: any) {
    // Garde TOUTE l'info de l'erreur originale
    console.error('[API] fetch threw:', networkErr);
    const detail = networkErr?.message || String(networkErr);
    const errorName = networkErr?.name || 'UnknownError';
    throw new Error(`Échec de connexion à ${url} — ${errorName}: ${detail}`);
  }
  
  let json: any;
  try {
    json = await res.json();
  } catch {
    console.error('[API] Non-JSON response, status:', res.status);
    throw new Error(`Erreur serveur (${res.status}) — réponse non-JSON`);
  }
  
  if (!res.ok || !json.success) {
    console.error('[API] Request failed:', res.status, json);
    throw new Error(json.error ?? `Request failed: ${res.status}`);
  }
  
  return json.data as T;
}

// ─── Products ────────────────────────────────
export const productsApi = {
  getAll: (params?: { category?: string; inStock?: boolean; search?: string }) => {
    const qs = new URLSearchParams();
    if (params?.category) qs.set('category', params.category);
    if (params?.inStock !== undefined) qs.set('inStock', String(params.inStock));
    if (params?.search) qs.set('search', params.search);
    const query = qs.toString() ? `?${qs}` : '';
    return request<any[]>(`/products${query}`);
  },
  getOne: (idOrSlug: string) => request<any>(`/products/${idOrSlug}`),
};

// ─── Orders ──────────────────────────────────
export const ordersApi = {
  createPublic: (data: {
    customerName: string;
    company?: string;
    email: string;
    phone?: string;
    country?: string;
    products: { name: string; quantity?: string; quantityUnit?: string }[];
    destinationAddress?: string;
    destinationPostalCode?: string;
    destinationCountry?: string;
    purchasePeriodStart?: string;
    purchasePeriodEnd?: string;
    message?: string;
    contactMethod?: 'email' | 'phone' | 'video';
    availability?: string;
    language?: string;
    currency?: string;
  }) =>
    request<{ id: string; order_number: string }>('/orders/public', {
      method: 'POST',
      body: JSON.stringify(data),
    }),
};
export const quotesApi = {
  create: (data: {
    customerName: string;
    company?: string;
    email: string;
    phone?: string;
    country?: string;
    products: string[];
    quantity?: string;
    destinationAddress?: string;
    destinationPostalCode?: string;
    destinationCountry?: string;
    purchasePeriodStart?: string;
    purchasePeriodEnd?: string;
    message?: string;
    contactMethod?: 'email' | 'phone' | 'video';
    availability?: string;
    language?: string;
  }) =>
    request<{ id: string }>('/quotes', {
      method: 'POST',
      body: JSON.stringify(data),
    }),
};
